<template>
    <div>
        <Dialog v-model:visible="visible" :style="{ width: '600px' }" header="Review Assessment Answers" :modal="true" class="p-fluid dialog-header" @hide="$emit('hide-dialog', true)">
            <div v-for="block in blocks" class="card my-3 border-1" :key="block.id">
                <h4 class="text-center">{{ block.label == 'user_block' ? 'User Profile' : block.label }}</h4>
                <Divider />
                <ul class="list-none p-0 m-0 surface-container">
                    <li v-for="attribute in block.attributes" class="py-3 px-2 border-bottom-1 surface-border" :key="attribute.id">
                        <div class="text-500 w-6 md:w-2 font-medium">{{ attribute.label }}</div>
                        <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ attribute.answer }}</div>
                    </li>
                </ul>
            </div>
        </Dialog>
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue';
//import { formatDate } from '@/helpers/date-formatter';
import { DateTime } from 'luxon';

const formStore = inject('formStore');
const visible = ref(true);
const blocks = ref([]);

onMounted(() => {
    loadBlockAnswers();
});

const loadBlockAnswers = () => {
    // fetch all the blocks/steps and its attributes from form store
    formStore.steps.forEach((step) => {
        // extract the specific step answers from formStore using the step code
        const stepAnswers = formStore.answers?.find((answer) => answer.current_step_code === step?.code)?.answers;
        let tempStepDetails = {};
        let tempAttributes = [];
        step?.block?.form_attributes?.map((attribute) => {
            // filter out the free text types P.S - You dont need to preview free text types
            if (![1, 2, 3].includes(parseInt(attribute.type))) {
                // extract answer of the particular attribute using its attribute code and map it here
                let attributeAnswer = stepAnswers?.find((stepAnswer) => stepAnswer.attribute_code === attribute.code)?.answer ?? 'N/A';
                // check if attribute is option type, if yes then extract the option value
                // DROP_DOWN: 8, MULTI_DROP_DOWN: 9, RADIO: 10, CHECKBOX: 11,
                if ([8, 9, 10, 11].includes(parseInt(attribute.type))) {
                    const selectedOption = attribute?.options?.find((option) => option?.value === attributeAnswer);
                    // check if the selected option is valid or not
                    attributeAnswer = selectedOption?.label ?? 'N/A';
                }
                // Else if check if its date type DATE:7
                else if (parseInt(attribute.type) === 7) {
                    //attributeAnswer = attributeAnswer ? formatDate(attributeAnswer) : 'N/A';

                    if (attributeAnswer !== 'N/A') {
                        attributeAnswer = DateTime
                            .fromJSDate(attributeAnswer)
                            .toLocaleString({
                                weekday: 'short',
                                month: 'short',
                                day: '2-digit',
                                year: 'numeric',
                            })
                    }
                }
                // check if its duration type
                else if (parseInt(attribute.type) === 12) {
                    if (attributeAnswer) {
                        let minVal = parseInt(attributeAnswer / 60);
                        let secVal = parseInt(attributeAnswer % 60);
                        attributeAnswer = `${minVal} mins and ${secVal} seconds`;
                    } else {
                        attributeAnswer = 'N/A';
                    }
                }

                // extract only few information and push it into the temp_form_attributes
                const attribute_obj = {
                    id: attribute.id,
                    label: attribute.label,
                    code: attribute.code,
                    answer: attributeAnswer,
                };
                tempAttributes.push(attribute_obj);
            }
        });
        // if there are attributes then push it into the blocks
        if (tempAttributes.length > 0) {
            tempStepDetails.id = step?.block_id;
            tempStepDetails.code = step?.code;
            tempStepDetails.label = step?.label;
            tempStepDetails.attributes = tempAttributes;

            // push the form_attributes into blocks
            blocks.value.push(tempStepDetails);
        }
    });
};
</script>

<style scoped>
li {
    display: flex;
    flex-direction: row;
}
li > div {
    display: flex;
    justify-content: left;
    align-items: center;
}
li > div:nth-child(odd) {
    width: 40% !important;
}
li > div:nth-child(even) {
    width: 60% !important;
}
</style>
